import React, { useEffect } from 'react';
import Loader from '../../utils/Loader';
import ProductsList from './productList';
import RecommendedProductList from './recommendedProdList';
import { getProductList } from '../../redux/buyCourse/buyCourse.actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import DefaultLayoutHOC from '../layoutHOC/defaultLayout';
import Container from 'react-bootstrap/Container';

const BuyCourse = ({ getProductList }) => {
	useEffect(() => {
		getProductList();
		Loader.hide();
	}, [getProductList]);

	return (
		<Container className="page-grid">
			<RecommendedProductList />
			<ProductsList />
		</Container>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		getProductList: () => dispatch(getProductList()),
	};
};

export default compose(
	connect(null, mapDispatchToProps),
	DefaultLayoutHOC,
)(BuyCourse);
